export enum Permission {
  MANAGE_USER = 'ROLE_MANAGE_USER',
  CREATE_TRANSACTIONS = 'ROLE_CREATE_TRANSACTIONS',
  MANAGE_PAYMENT_CONTACTS = 'ROLE_MANAGE_PAYMENT_CONTACTS',
  VIEW_ACTIVITY = 'ROLE_VIEW_ACTIVITY',
  RECEIVE_TRANSACTION_STATUS_NOTIFICATIONS = 'ROLE_RECEIVE_TRANSACTION_STATUS_NOTIFICATIONS',
  MANAGE_CUSTOMER = 'ROLE_MANAGE_CUSTOMER',
}
